import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import Footer from './components/Footer';
import AboutSection from './pages/AboutSection';
import AdmissionsSection from './pages/AdmissionsSection';
import ResultSection from './pages/ResultSection';
import ResearchSection from './pages/ResearchSection';
import ContactSection from './pages/ContactSection';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import Sitemap from './pages/Sitemap';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutSection />} />
          <Route path="/admission" element={<AdmissionsSection />} />
          <Route path="/results" element={<ResultSection />} />
          <Route path="/research" element={<ResearchSection />} />
          <Route path="/contact" element={<ContactSection />} />
          <Route path="/policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/sitemap" element={<Sitemap />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;